export default __webpack_public_path__ + "assets/media/upload-finished-right.eecd5146.png";